(function () {
  $(document).on('submit', '#search-pickup-form', function (e) {
    e.preventDefault();
    const searchTerm = $('#pickupSearchInput').val().toUpperCase();
    const locationId = $(this).data('location-id');

    $('#searchResultsList, #uiPlaceholder, #searchAlert').addClass('d-none');
    $('#uiLoading').removeClass('d-none');

    $.ajax({
      type: 'POST',
      url: '/api/v1/private/order/search-pickup',
      data: {
        searchTerm,
        locationId,
      },
      success: function (response) {
        const { data, message, status } = response;

        if (
          data.status !== undefined &&
          data.status !== null &&
          data.status == 'captured_and_delivered'
        ) {
          $('#searchResultsList').empty();
          $('#searchResultsList').addClass('d-none');

          showAlert(
            `<b>Allerede utlevert!</b><br>Denne ble hentet: ${data.deliveredAt}`,
            'warning'
          );
          return;
        }

        if (
          data.products !== undefined &&
          data.products !== null &&
          data.products.length > 0
        ) {
          setClassicLocationCart({
            ...locationCart,
            products: data.products,
            orderId: data.orderId,
          }).always(function () {
            clearSearchState();
          });
          return;
        }

        if (data.html !== undefined && data.html !== null) {
          $('#searchResultsList').html(data.html);
          $('#searchResultsList').removeClass('d-none');
          return;
        }

        if (message) {
          $('#searchResultsList').empty();
          $('#searchResultsList').addClass('d-none');
          showAlert(message, 'info');
        }
      },
      error: function (xhr) {
        if (xhr.responseJSON && xhr.responseJSON.redirect_url) {
          window.location.href = xhr.responseJSON.redirect_url;
        }

        if (xhr.responseJSON && xhr.responseJSON.message) {
          showAlert(xhr.responseJSON.message, 'danger');
        }
      },
    }).always(function () {
      $('#uiLoading').addClass('d-none');
    });
  });

  $(document).on('click', '#pickup-register-btn', function () {
    const orderId = $(this).data('order-id');

    $.ajax({
      type: 'POST',
      url: '/api/v1/private/order/register-pickup',
      data: {
        orderId,
        orderProducts: locationCart.products,
      },
      success: function (response) {
        const { data, message, status } = response;

        if (
          data.success !== undefined &&
          data.success !== null &&
          data.success
        ) {
          showToast({
            type: 'success',
            message: message || 'Henting registrert!',
            duration: 3000,
          });

          clearSearchState();
          emptyAllCart();
        }
      },
      error: function (xhr) {
        if (xhr.responseJSON && xhr.responseJSON.redirect_url) {
          window.location.href = xhr.responseJSON.redirect_url;
        }
      },
    });
  });

  $(document).on('click', '.btn-process', function () {
    const orderId = $(this).attr('data-order-id');
    const cartProductsJSON = $(this).attr('data-cart-products');
    const cartProducts = JSON.parse(cartProductsJSON);

    setClassicLocationCart({
      ...locationCart,
      products: cartProducts,
      orderId,
    }).always(function () {
      $('#pickup-search-modal').modal('hide');
    });
  });

  $(document).on('submit', '#resend-pickup-code-form', function (e) {
    e.preventDefault();
    const emailInput = $(this).find('input[name="email"]');
    const submitBtn = $(this).find('button[type="submit"]');

    const email = emailInput.val().trim();
    const orderId = submitBtn.attr('data-order-id');

    emailInput.prop('disabled', true);
    submitBtn.prop('disabled', true);
    submitBtn.html('<div class="loader p-0"></div>');

    $.ajax({
      type: 'POST',
      url: '/api/v1/orders/resend-pickup-code',
      data: {
        email,
        orderId,
      },
      success: function (response) {
        const { data, message, status } = response;

        if (
          data.success !== undefined &&
          data.success !== null &&
          data.success
        ) {
          showToast({
            type: 'success',
            message: message || 'Hentekode sendt på nytt!',
            duration: 3000,
            position: 'bottom-right',
          });
        }
      },
    }).always(function () {
      emailInput.prop('disabled', false);
      submitBtn.prop('disabled', false);
      submitBtn.html('Send e-post');
    });
  });

  function clearSearchState() {
    if ($('#pickup-search-modal').hasClass('show')) {
      $('#pickup-search-modal').modal('hide');
    }
    $('#searchResultsList, #searchAlert').addClass('d-none');
    $('#searchResultsList').empty();
    $('#pickupSearchInput').val('');
    $('#uiPlaceholder').removeClass('d-none');
  }

  function showAlert(msg, type) {
    $('#searchAlert')
      .html(`<div class="alert alert-${type} mb-0">${msg}</div>`)
      .removeClass('d-none');
  }
})(jQuery);
